<template>
  <!-- 借阅统计 -->
  <div style="">
    <!-- <div class="main report_search" style="height:inherit;"> -->
      <!-- <el-form inline class="demo-form-inline" size='small'>
        <el-form-item label="用户账号：">
          <el-cascader
            ref="cascader"
            :options="archGrpids"
            v-model="value"
            clearable
            :show-all-levels="false"
            @change="handleChange"
            :props='{
              multiple: true,
              expandTrigger: "hover",
              value: "archgrpid",
              label: "farchgroupname",
              children: "childNodes"
            }'
            collapse-tags
            achange-on-select
          ></el-cascader>
          <el-input placeholder='在这儿查询指定用户..'></el-input>
        </el-form-item>
      </el-form> -->

      <!-- <el-button size='small' icon='el-icon-search' type="primary" @click="">查询</el-button> -->

    <!-- </div> -->
    
    <!-- 图表 v-mask.toSearch.init='[0]' -->
    <div style="display:flex;height:inherit;" vs.height='height||H-179' >
      <div v-if=' drawtype === "drawLine" ' id="MYEchart" ref="homeChart"></div>
      <div v-else-if=' drawtype === "drawCake" ' id="MYEchart" ref="homeChartPie" vs.margin-left=" drawtype === 'drawLine' && 20"></div>
    </div>

  </div>
</template>

<script>

import echarts from "echarts";
const W = window;

// { name: "", value: "" } => 柱状图( Data1[ name ], Data2[ value ] )   饼图( Data1[ name ], Data2[ name, value ] )
export default {
  name: 'MyEchart',
  props: [ 'height', 'type', 'title', 'X', 'Y' ],
  data() {
    return {
      
      drawtype: '',
      CascaderProps: {
        multiple: true,
        expandTrigger: "hover",
        value: "archgrpid",
        label: "farchgroupname",
        children: "childNodes"
      },

    };
  },
  components: {},
  methods: {

    //=============== 绘制柱表 =====================
    drawLine(d1, d2) {
      //echarts 实例化
      var myChart = echarts.init( this.$refs.homeChart );
      // 基于准备好的dom，初始化echarts实例
      myChart.setOption({
        title: { text: this.title || "?",  }, //馆藏情况统计 "档案借阅统计"
        tooltip: {},
        legend: {
          data: [ this.Y || "" ], // 例如: 头部 数量
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: {
              yAxisIndex: "none"
            },
            dataView: { show: true, readOnly: false },
            magicType: { show: true, type: ["line", "bar"] },
            restore: { show: true },
            saveAsImage: { show: true }
          }
        },
        xAxis: {
          data: d1 || [],
          name: this.X || "?", // "/类别"
        },
        yAxis: {},
        series: [
          {
            name: this.Y || "?", // "数量",
            type: "bar",
            smooth: true,
            barCategoryGap: "60%",
            data: d2 || [],
            markPoint: {
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" }
              ]
            },
            itemStyle: {
              color: W.$Themecolor || "darkred", //"#89C8DB" //柱状图背景色
            }
          }
        ]
      });
    },

    //=============== 饼图表 =========================
    drawCake(d1, d2) {
      var myChartPie = echarts.init( this.$refs.homeChartPie );
      myChartPie.setOption({
        title: {
          text: this.title || "?", //"档案借阅统计",
          x: "center"
        },
        color: [
          "#1E6498",
          "#3A90BA",
          "#58ABCC",
          "#2EC7C9",
          "#72BBD7",
          "#DF9499",
          "#FFB980",
          "#AC8BC4",
          "#90C526",
          "#FF0F00",
          "#C15E75",
          "#9D96F5",
          "#FF9F7F"
        ],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          orient: "vertical",
          left: "left",
          data: d1 || []
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: d2 || [],
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)"
              }
            }
          }
        ]
      });
    },

    // ============= 搜索框 按钮=====================
    toSearch: async function() {
      
      data.forEach(v => {
        temp1.push(v.name);
        temp2.push(v.value);
      });

      this.drawLine(temp1, temp2);
      this.drawCake(temp1, data);

    },

  },
  created() {
    // console.error(this.$vnode.data.directives);
    this.$vnode.data.directives.find(dir=>{
      return ( dir = dir.rawName ).includes('.drawLine')
             ? this.drawtype = 'drawLine'
             : dir.includes('.drawCake')
             ? this.drawtype = 'drawCake'
             : false;
    });
    // this.toSearch();
    // this.getGrpName(); //类别
    // this.getkeeplimitSelect("archyear"); //年度
  },
  mounted() {
    // this.drawLine();
  }
};

</script>


<style xscoped>
  #MYEchart {
    width: 100%;
    background: #fff;
    border: 1px solid #ccc;
    padding-left: 10px;
    padding-right: 10px;
    padding-top: 10px;
    height: 100%;
    box-sizing: border-box;
  }
  #MYEchart > div:first-child {
    width:100%!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/$MyEchart.vue